import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { UserContextService } from '../../services/user-context/user-context.service';
import { isBefore } from 'date-fns';
import { skip, take } from 'rxjs';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-about',
  imports: [
    CommonModule,
    TranslatePipe,
    IconComponent,
    NzModalModule,
    NzDividerComponent,
    LoadingSpinnerComponent,
    NzSpinModule,
    NzIconModule,
  ],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.less'],
})
export class AboutComponent {
  private readonly userContextService = inject(UserContextService);
  isVisible = false;

  versions = computed(() => [
    {
      name: 'ABOUT.VERSIONS.SOFTWARE',
      value: DPQA_CLOUD_VERSION,
    },
    {
      name: 'ABOUT.VERSIONS.DATAPLANE',
      value: (this.userContextService
        .dataplaneVersion()
        ?.sort((a, b) => (isBefore(new Date(a.lastPingedAt || 0), new Date(b.lastPingedAt || 0)) ? 1 : -1))
        .at(0)?.version || ''),
    },
  ]);

  externalLinks = computed(() => [
    {
      name: 'ABOUT.EXTERNAL_LINKS.MANUAL',
      url: this.userContextService.ifuUrl(),
      icon: 'book-open',
    },
    {
      name: 'ABOUT.EXTERNAL_LINKS.PRIVACY_POLICY',
      url: 'https://www.barco.com/en/about/trust-center/product-privacy-statement',
      icon: 'shield-secured',
    },
    {
      name: 'ABOUT.EXTERNAL_LINKS.EULA',
      url: this.userContextService.eulaUrl(),
      icon: 'license',
    },
  ]);

  loadingExternalName = signal<string | undefined>(undefined);

  clickExternalLink(name: string): void {
    this.loadingExternalName.set(name);
    this.userContextService.refreshUserContext();

    this.userContextService.userContext$.pipe(skip(1), take(1)).subscribe(() => {
      this.loadingExternalName.set(undefined);
      window.open(this.externalLinks().find((l) => l.name === name)?.url, '_blank', 'noopener,noreferrer');
    });
  }

  copy(type: string): void {
    navigator.clipboard.writeText(this.versions().find((v) => v.name === type)?.value || '');
  }
}
